import * as React from 'react'

import { BankToAutoLinkingProps } from '@ally/transmitigator'
import { Space, TextHeading } from '@ally/metronome-ui'
import { LoginHeading } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'
import { CIAMErrorBanner, LoggedInAlert, StyledTextBody } from '../Shared'
import { AutoLoginForm } from './AutoLoginForm'
import { useHostServices } from '../../HostServices'

const BankToAutoLinkingContent: React.FC<BankToAutoLinkingProps> = ({
  onComplete,
  status,
  userRelationships,
  authenticatedUsername,
  error,
}) => {
  const { analytics } = useHostServices()

  React.useEffect(() => {
    analytics.trackPageView({
      eventType: 'pageview',
      pageName: 'AOS:Login:Link Auto Account',
    })
  }, [])

  return (
    <>
      <LoggedInAlert
        roles={userRelationships}
        username={authenticatedUsername}
      />

      <LoginHeading title="Let's link up." />

      <Space mb="lg">
        <StyledTextBody size="sm" tag="p">
          Link your Ally accounts and manage all of your info in one spot, with
          one set of credentials. More to see, with less to remember.
        </StyledTextBody>
      </Space>

      <Space mb="md">
        <TextHeading tag="h2" size="xs">
          Enter your Auto info to link your accounts and continue to Snapshot.
        </TextHeading>
      </Space>

      <CIAMErrorBanner error={error} />

      <AutoLoginForm onComplete={onComplete} status={status} />
    </>
  )
}

export const BankToAutoLinking: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'BankToAutoLinking') {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <BankToAutoLinkingContent {...activeScreen.payload} />
}
